import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ComplianceStatusHttpModel } from '../../http/compliance/compliance-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const ComplianceSummaryActions = createActionGroup({
  source: 'Compliance Summary',
  events: {
    'Load Compliance Summary': emptyProps(),
  },
});

export const ComplianceSummaryAPIActions = createActionGroup({
  source: 'Compliance Summary API',
  events: {
    'Loaded Compliance Summary Successfully': props<{
      complianceSummary: ComplianceStatusHttpModel;
    }>(),
    'Loaded Compliance Summary Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
